import React from "react";

const TRANS = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

const TopVenuesDisplay = ({ venues }) => (
  <div className="layout">
    {
      venues.map((venue, index) => {
        const key = `${venue.name.replace(/\S/, "_")}_${index}`;

        return (
          <div key={key} className="layout__item u-1/1-mobile u-1/2 u-1/3-desk">
            <div className="offer offer--ygt offer--top-100">
              <a href={venue.slug}>
                <div className="offer__img-container">
                  <picture data-defer="">
                    <img
                      alt={venue.name}
                      decoding="async"
                      height="1"
                      width="1"
                      data-srcset={venue.images.thumbLg}
                      data-type="top-100"
                      src={TRANS}
                    />
                  </picture>
                  <div className="offer__flags">
                    <div className="offer__flag">{index + 1}</div>
                  </div>
                </div>
              </a>

              <div className="offer__container">
                <a href={venue.slug}>
                  <h4 className="offer__title media media--flush">
                    <div className="media__img">
                      <img alt="" className={`sprite_flags_${venue.location_sprite_code}`} />
                    </div>
                    <div className="media__body"><div>{venue.name}</div></div>
                  </h4>
                </a>
              </div>
            </div>
          </div>
        );
      })
    }
  </div>
);

export default TopVenuesDisplay;



// WEBPACK FOOTER //
// ./components/top_venues/TopVenuesDisplay.jsx